import React from 'react'
import '../../styles/Expertise/ExpertiseAccessibility.css'
import { Fade } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import AccordionText from '../Utils/AccordionText'
import expertiseAccessibilitySection2 from '../../assets/expertise/expertise-accessibility-section2.jpg'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function ExpertiseAccessibility() {

    const section1AccordionData = [
        {
            title: "Identifier les obstacles :",
            text: "Examiner minutieusement les installations pour repérer les éléments qui peuvent représenter une barrière à l’accès et à l’usage des locaux par les personnes handicapées."
        }, {
            title: "Proposer des solutions :",
            text: "Fournir des recommandations concrètes et adaptées pour lever ces obstacles, en conformité avec les exigences légales et les normes d’accessibilité."
        }, {
            title: "Planifier les travaux :",
            text: "Établir un calendrier et une estimation des coûts pour la mise en œuvre des améliorations nécessaires à l’accessibilité."
        },
    ]

    const section3Accordion1Data = [
        {
            title: "Expertise spécialisée :",
            text: "Notre connaissance approfondie des normes d’accessibilité garantit une évaluation précise et conforme aux réglementations."
        }, {
            title: "Conseil personnalisé :",
            text: "Nous vous accompagnons dans la définition des solutions les plus adaptées à votre situation spécifique, optimisant ainsi l’investissement requis pour la mise en conformité."
        }, {
            title: "Valorisation de votre établissement :",
            text: "Au-delà de la conformité réglementaire, améliorer l’accessibilité de votre établissement contribue à son attractivité et à sa réputation, tout en affirmant votre engagement social."
        }
    ]

    const section3Accordion2Data = [
        {
            title: "1. Évaluation préliminaire :",
            text: "Notre équipe réalise une première visite pour comprendre la configuration des lieux et identifier les principaux enjeux d’accessibilité."
        }, {
            title: "2. Diagnostic sur site :",
            text: "Nous procédons à une inspection détaillée de l’établissement, évaluant les accès, les circulations intérieures, les équipements et les services sous l’angle de l’accessibilité."
        }, {
            title: "3. Rapport et recommandations :",
            text: "Vous recevez un rapport exhaustif présentant les résultats du diagnostic, accompagné de propositions d’aménagement ou de modification pour améliorer l’accessibilité, ainsi qu’une estimation des investissements nécessaires."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic accessibilité handicapé - E5M Diagnostics" />
                <meta name="description" content="Diagnostic accessibilité handicapé sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic accessibilité handicapé - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic accessibilité handicapé sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/diagnostic-accessibilité-handicapé" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/diagnostic-accessibilité-handicapé" />
            </Helmet>

            <BrowserView>
                <div id='expertiseAccessibility'>
                    <div id='header'>
                        <div id='expertiseAccessibilityHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Diagnostic accessibilité handicapé</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='expertiseAccessibilitySection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseAccessibilitySection1Left'>
                                    <div className='sectionText'>
                                        Le diagnostic accessibilité handicapés est une évaluation essentielle visant à garantir l’accès et l’usage des bâtiments et espaces publics aux personnes en situation de handicap. Cette démarche, encadrée par la réglementation en
                                        vigueur, est fondamentale pour promouvoir une société inclusive et respectueuse des droits de chacun. E5M Diagnostics se positionne en tant que partenaire pour la réalisation de ce diagnostic, proposant expertise et accompagnement
                                        pour rendre vos infrastructures accessibles à tous.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='expertiseAccessibilitySection1Right'>
                                    <div className='sectionTitle'>Objectifs du diagnostic accessibilité handicapés</div>
                                    <div className='sectionText'>
                                        Le diagnostic accessibilité handicapés a pour but de :
                                    </div>
                                    <div className='sectionAccordionDark'>
                                        <Accordion>
                                            {section1AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseAccessibilitySection2'>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='expertiseAccessibilitySection2Left'>
                                    <h1 className='sectionTitle'>Cadre Législatif</h1>
                                    <div className='sectionText'>
                                        La législation concernant l’accessibilité des établissements recevant du public (ERP) et des installations ouvertes au public est rigoureuse et vise à assurer une égalité d’accès pour tous. Le diagnostic accessibilité handicapés
                                        est donc obligatoire pour tous les ERP et installations existants qui doivent se conformer aux normes d’accessibilité. En conformité avec la loi du 11 février 2005, le décret du 17 mai 2006, numéro 2006-555, exige l’exécution d’un
                                        diagnostic d’accessibilité pour les personnes handicapées au sein des Établissements Recevant du Public (ERP) relevant des catégories 1 à 4.
                                    </div>
                                    <div className='sectionText'>
                                        Les délais impartis pour effectuer ce diagnostic obligatoire d’accessibilité ERP étaient déterminés au :
                                    </div>
                                    <div className='sectionText'>
                                        <ul>
                                            <li>1er janvier 2010 pour les ERP existants des catégories 1 et 2, ainsi que pour ceux de 3ème et 4ème catégories appartenant à l’État, aux établissements publics de l’État, ou pour lesquels l’État a contractuellement pris en charge la responsabilité de propriété.</li>
                                            <li>1er janvier 2011 pour les établissements de 3ème et 4ème catégories, à l’exception de ceux mentionnés précédemment.</li>
                                            <li>Les ERP de catégorie 5 n’étaient soumis à aucune obligation spécifique concernant ce diagnostic. Cependant, qu’ils aient été effectués ou non, ces diagnostics sont désormais indispensables pour élaborer un Agenda d’Accessibilité Programmée (Ad’AP) ainsi que pour planifier les travaux d’accessibilité requis. Ils servent de fondement à la démarche d’amélioration de l’accessibilité d’un bâtiment, et leur exactitude est cruciale. Un diagnostic précis de l’accessibilité pour les personnes handicapées de vos installations est le premier pas vers la définition d’un plan d’action efficace, garantissant une mise en conformité optimale avec la réglementation.</li>
                                        </ul>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='expertiseAccessibilitySection2Right'>
                                    <img src={expertiseAccessibilitySection2} id='expertiseAccessibilitySection2Image' alt='expertise-accessibility-section2' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseAccessibilitySection3'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseAccessibilitySection3Left'>
                                    <h1 className='sectionTitle'>Avantages de réaliser un diagnostic avec E5M Diagnostics</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section3Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseAccessibilitySection3Right'>
                                    <h1 className='sectionTitle'>Réalisation du diagnostic accessibilité handicapés</h1>
                                    <div className='sectionText'>
                                        Pour mener à bien cette mission, E5M Diagnostics suit une démarche structurée :
                                    </div>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section3Accordion2Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='expertiseAccessibilitySection4'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitle'>Faciliter la vie des handicapés dans un logement</h1>
                            <div className='sectionText'>
                                Le diagnostic accessibilité handicapés est une étape clé vers une société plus inclusive, permettant à tous les individus, quelles que soient leurs capacités, de participer pleinement à la vie sociale et économique. En confiant cette mission à E5M Diagnostics, vous assurez non seulement la conformité de vos installations, mais vous œuvrez également pour l’égalité et le respect de tous.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='expertiseAccessibility'>
                    <div id='header'>
                        <div id='expertiseAccessibilityHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Diagnostic accessibilité handicapé</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='expertiseAccessibilitySection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <div className='sectionTextMobile'>
                                Le diagnostic accessibilité handicapés est une évaluation essentielle visant à garantir l'accès et l'usage des bâtiments et espaces publics aux personnes en situation de handicap. Cette démarche, encadrée par la réglementation en
                                vigueur, est fondamentale pour promouvoir une société inclusive et respectueuse des droits de chacun. E5M Diagnostics se positionne en tant que partenaire pour la réalisation de ce diagnostic, proposant expertise et accompagnement
                                pour rendre vos infrastructures accessibles à tous.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <div className='sectionTitleMobile'>Objectifs du diagnostic accessibilité handicapés</div>
                            <div className='sectionTextMobile'>
                                Le diagnostic accessibilité handicapés a pour but de :
                            </div>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section1AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseAccessibilitySection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Cadre Législatif</h1>
                            <div className='sectionTextMobile'>
                                La législation concernant l'accessibilité des établissements recevant du public (ERP) et des installations ouvertes au public est rigoureuse et vise à assurer une égalité d'accès pour tous. Le diagnostic accessibilité handicapés
                                est donc obligatoire pour tous les ERP et installations existants qui doivent se conformer aux normes d'accessibilité. En conformité avec la loi du 11 février 2005, le décret du 17 mai 2006, numéro 2006-555, exige l'exécution d'un
                                diagnostic d'accessibilité pour les personnes handicapées au sein des Établissements Recevant du Public (ERP) relevant des catégories 1 à 4.
                            </div>
                            <div className='sectionTextMobile'>
                                Les délais impartis pour effectuer ce diagnostic obligatoire d'accessibilité ERP étaient déterminés au :
                            </div>
                            <div className='sectionTextMobile'>
                                <ul>
                                    <li>1er janvier 2010 pour les ERP existants des catégories 1 et 2, ainsi que pour ceux de 3ème et 4ème catégories appartenant à l'État, aux établissements publics de l'État, ou pour lesquels l'État a contractuellement pris en charge la responsabilité de propriété.</li>
                                    <li>1er janvier 2011 pour les établissements de 3ème et 4ème catégories, à l'exception de ceux mentionnés précédemment.</li>
                                    <li>Les ERP de catégorie 5 n'étaient soumis à aucune obligation spécifique concernant ce diagnostic. Cependant, qu'ils aient été effectués ou non, ces diagnostics sont désormais indispensables pour élaborer un Agenda d'Accessibilité Programmée (Ad'AP) ainsi que pour planifier les travaux d'accessibilité requis. Ils servent de fondement à la démarche d'amélioration de l'accessibilité d'un bâtiment, et leur exactitude est cruciale. Un diagnostic précis de l'accessibilité pour les personnes handicapées de vos installations est le premier pas vers la définition d'un plan d'action efficace, garantissant une mise en conformité optimale avec la réglementation.</li>
                                </ul>
                            </div>
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <img src={expertiseAccessibilitySection2} id='expertiseAccessibilitySection2ImageMobile' alt='expertise-accessibility-section2' />
                        </Fade>
                    </div>
                    <div id='expertiseAccessibilitySection3Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Avantages de réaliser un diagnostic avec E5M Diagnostics</h1>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section3Accordion1Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Réalisation du diagnostic accessibilité handicapés</h1>
                            <div className='sectionTextMobile'>
                                Pour mener à bien cette mission, E5M Diagnostics suit une démarche structurée :
                            </div>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section3Accordion2Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseAccessibilitySection4Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Faciliter la vie des handicapés dans un logement</h1>
                            <div className='sectionTextMobile'>
                                Le diagnostic accessibilité handicapés est une étape clé vers une société plus inclusive, permettant à tous les individus, quelles que soient leurs capacités, de participer pleinement à la vie sociale et économique. En confiant cette mission à E5M Diagnostics, vous assurez non seulement la conformité de vos installations, mais vous œuvrez également pour l'égalité et le respect de tous.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>




    )

}

export default ExpertiseAccessibility